<template>
  <div id="app">
    <my-header></my-header>
    <router-view></router-view>
    <my-footer></my-footer>
    <my-auth></my-auth>
  </div>
</template>

<script>
import MyHeader from "./sub/MyHeader";
import MyFooter from "./sub/MyFooter";
import MyAuth from "../../components/auth/MyAuth";
export default {
  name: "Base",
  components: { MyAuth, MyFooter, MyHeader }
};
</script>

<style scoped></style>
